import { Routes, Route } from "react-router-dom"
import Main from './components/Main'
import AccidentesTrabajo from './components/AccidentesTrabajo'
import Sucesiones from './components/Sucesiones'
import AccidentesTransito from './components/AccidentesTransito'
import EnfermedadesProfesionales from './components/EnfermedadesProfesionales'
import CiudadaniaItaliana from "./components/CiudadaniaItaliana"
import CiudadaniaItalianaServicios from "./components/CiudadaniaItalianaServicios"
import RegistroMarcas from "./components/RegistroMarcas"
import Gestoria from "./components/Gestoria"
import NotFound from "./components/NotFound"
import Blog from "./components/Blog"
import BlogPost from "./components/BlogPost"
import { BlogProvider } from "./contexts/BlogContext"
import { FeatureFlagProvider, useFeatureFlags } from "./contexts/FeatureFlagContext"

function AppRoutes() {
  const { isEnabled } = useFeatureFlags()
  const blogEnabled = isEnabled('blog_enabled')

  return (
    <Routes>
      <Route path="/" element={ <Main/> } />
      <Route path="sucesiones" element={ <Sucesiones/> } />
      <Route path="accidentes-trabajo" element={ <AccidentesTrabajo/> } />
      <Route path="accidentes-transito" element={ <AccidentesTransito/> } />
      <Route path="enfermedades-profesionales" element={ <EnfermedadesProfesionales/> } />
      <Route path="ciudadania-italiana" element={ <CiudadaniaItaliana/> } />
      <Route path="ciudadania-italiana-servicios" element={ <CiudadaniaItalianaServicios/> } />
      <Route path="registro-marcas" element={ <RegistroMarcas/> } />
      <Route path="gestoria" element={ <Gestoria/> } />
      {blogEnabled && <Route path="blog" element={ <Blog/> } />}
      {blogEnabled && <Route path="blog/:id" element={ <BlogPost/> } />}
      <Route path='*' element={ <NotFound />}/>
    </Routes>
  )
}

function App() {
  return (
    <FeatureFlagProvider>
      <BlogProvider>
        <div className="App">
          <AppRoutes />
        </div>
      </BlogProvider>
    </FeatureFlagProvider>
  );
}

export default App;
